import { useTranslation } from 'react-i18next';
import { Badge } from '@bliks-io/ui';

export function PublishStatusBadge({ published }: { published: boolean }) {
  const { t } = useTranslation();
  return (
    <Badge colorScheme={published ? 'success' : 'neutral'} size="sm">
      {t(published ? 'partnerContent.status.published' : 'partnerContent.status.draft')}
    </Badge>
  );
}
